export const nohblePluginMeta = {
  id: 'nohble'
}
